import { getSha256Hash } from './getSha256Hash';

/**
 * Deterministic 32-character id from an array of strings (SHA-256 prefix over UTF-8 JSON).
 *
 * Uses `JSON.stringify(parts)` so **array order** and each string’s exact contents (including
 * Unicode) define the id—e.g. `['a,b','c']` and `['a','b,c']` produce different values.
 */
export const hashStringArrayToStableId = async (parts: string[]): Promise<string> => {
  const fullHex = await getSha256Hash(JSON.stringify(parts));
  return fullHex.slice(0, 32);
};
